import { Component, OnInit } from '@angular/core';
import {Router}from'@angular/router';
import * as firebase from 'firebase'


@Component({
  selector: 'app-data',
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.scss']
})
export class DataComponent implements OnInit {
  active = 1;

  constructor(private router:Router) { }

  ngOnInit(): void {
  }

  logout() {
    firebase.auth().signOut();
    this.router.navigateByUrl('/home');
  }

}
